import{yieldToMainThread}from'@theme/utilities';import{Component}from'@theme/component';

class FlyToCart extends Component{
  source;
  useSourceSize=false;
  destination;

  connectedCallback(){
    super.connectedCallback();
    const o=new IntersectionObserver((e)=>{
      let s=null,d=null;
      e.forEach((n)=>{
        if(n.target===this.source)s=n.boundingClientRect;
        else if(n.target===this.destination)d=n.boundingClientRect;
      });
      if(s&&d)this.#a(s,d);
      o.disconnect();
    });
    o.observe(this.source);
    o.observe(this.destination);
  }

  #a=async(s,d)=>{
    const sx=s.left+s.width/2,sy=s.top+s.height/2,p=this.style;
    if(this.useSourceSize){
      p.setProperty('--width',`${s.width}px`);
      p.setProperty('--height',`${s.height}px`);
    }
    p.setProperty('--start-x',`${sx}px`);
    p.setProperty('--start-y',`${sy}px`);
    p.setProperty('--travel-x',`${d.left+d.width/2-sx}px`);
    p.setProperty('--travel-y',`${d.top+d.height/2-sy}px`);
    await yieldToMainThread();
    await Promise.allSettled(this.getAnimations().map((a)=>a.finished));
    this.remove();
  };
}

if(!customElements.get('fly-to-cart'))customElements.define('fly-to-cart',FlyToCart);